var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M298.912,60.231c-8.114,0-14.692-6.577-14.692-14.692V29.383H172.564V45.54 c0,8.114-6.577,14.692-14.692,14.692s-14.692-6.577-14.692-14.692V14.692C143.181,6.577,149.758,0,157.872,0h141.04 c8.114,0,14.692,6.577,14.692,14.692V45.54C313.604,53.654,307.025,60.231,298.912,60.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M366.494,512c-61.568,0-111.657-50.088-111.657-111.657s50.088-111.657,111.657-111.657 S478.15,338.775,478.15,400.343S428.062,512,366.494,512z M366.494,318.07c-45.365,0-82.273,36.908-82.273,82.273 s36.908,82.273,82.273,82.273c45.365,0,82.273-36.908,82.273-82.273S411.859,318.07,366.494,318.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M297.687,483.344H104.963c-7.575,0-13.907-5.758-14.626-13.299L60.951,161.527 c-0.392-4.12,0.971-8.214,3.755-11.277c2.786-3.062,6.732-4.807,10.87-4.807h305.628c8.114,0,14.692,6.577,14.692,14.692 c0,8.114-6.577,14.692-14.692,14.692H91.735l26.588,279.134h179.363c8.114,0,14.692,6.577,14.692,14.692 S305.801,483.344,297.687,483.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M158.382,424.577c-7.487,0-13.884-5.694-14.608-13.299l-14.498-152.201 c-0.768-8.077,5.155-15.248,13.233-16.018c8.091-0.767,15.25,5.155,16.018,13.233l14.498,152.201 c0.768,8.077-5.155,15.248-13.233,16.018C159.318,424.557,158.848,424.577,158.382,424.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M306.99,338.486c-0.483,0-0.971-0.025-1.462-0.072c-8.075-0.798-13.973-7.991-13.175-16.065 l6.533-66.108c0.798-8.076,7.995-13.964,16.065-13.175c8.075,0.798,13.973,7.991,13.175,16.065l-6.533,66.108 C320.844,332.82,314.453,338.486,306.99,338.486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M367.562,318.096c-0.05,0-0.1,0-0.15,0c-0.292-0.003-0.582-0.012-0.873-0.022l-0.154-0.004 c-8.113,0-14.636-6.577-14.636-14.692c0-2.478,0.619-4.813,1.71-6.861l3.83-40.223c0.77-8.077,7.935-13.997,16.018-13.233 c8.077,0.77,14.001,7.941,13.233,16.018l-4.355,45.72C381.466,312.345,375.127,318.096,367.562,318.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M328.867,452.662c-3.76,0-7.521-1.434-10.388-4.303c-5.737-5.737-5.737-15.04,0-20.778 l75.254-75.254c5.737-5.737,15.04-5.737,20.778,0c5.737,5.737,5.737,15.04,0,20.778l-75.254,75.254 C336.388,451.228,332.627,452.662,328.867,452.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M404.121,452.662c-3.76,0-7.521-1.434-10.389-4.303l-75.254-75.254 c-5.737-5.737-5.737-15.04,0-20.778c5.737-5.737,15.04-5.737,20.778,0l75.254,75.254c5.737,5.737,5.737,15.04,0,20.778 C411.641,451.228,407.88,452.662,404.121,452.662z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.541,
    y: 101.368,
    style: {
      fill: "#F4B2B0"
    },
    width: 359.696,
    height: 79.893
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M408.242,195.95h-359.7c-8.114,0-14.692-6.577-14.692-14.692v-79.89 c0-8.114,6.577-14.692,14.692-14.692h359.7c8.114,0,14.692,6.577,14.692,14.692v79.889 C422.933,189.371,416.356,195.95,408.242,195.95z M63.233,166.567H393.55V116.06H63.233V166.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M228.392,424.577c-8.114,0-14.692-6.577-14.692-14.692V256.001c0-8.114,6.577-14.692,14.692-14.692 s14.692,6.577,14.692,14.692v153.885C243.084,418,236.505,424.577,228.392,424.577z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.08333029.svg";
export { ForwardRef as ReactComponent };